import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { auth } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("working"); // working | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setMsg("Missing token."); return; }
    (async () => {
      try {
        await auth.verifyEmail(token);
        setState("ok");
      } catch (e) {
        setState("error");
        setMsg(e?.response?.data?.detail || "Verification failed");
      }
    })();
  }, [token]);

  return (
    <div className="login-shell" data-testid="verify-page">
      <div className="login-card">
        <div className="login-logo"><span className="logo-icon">⬡</span><span className="app-name">GovCo<span>.AI</span></span></div>
        {state === "working" && <p className="sub"><span className="spinner" /> Verifying your email…</p>}
        {state === "ok" && (
          <>
            <h2>Email verified ✅</h2>
            <p className="sub">Your account is ready.</p>
            <Link className="btn btn-primary w-full" style={{ justifyContent: "center", marginTop: 14 }} to="/login">Sign in</Link>
          </>
        )}
        {state === "error" && (
          <>
            <h2>Verification failed</h2>
            <div className="err">{msg}</div>
            <Link className="btn btn-ghost w-full" style={{ justifyContent: "center", marginTop: 14 }} to="/login">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
